import React from 'react';
/* Website logos  */
import Farmacie from '../assets/logos/farmacie.png';
import Felicia from '../assets/logos/felicia.png';
import Maximum from '../assets/logos/maximum.png';
import Purcari from '../assets/logos/purcari.png';
import Invito from '../assets/logos/invito.png';
import Verde from '../assets/logos/verde.png';

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const Wrapper = styled.div`
  max-width: 100%;
  overflow-x: scroll;
  display: flex;
  margin-bottom: 24px;
  margin-right: 22px;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* Chrome/Safari/Webkit */
  }
`;

const LogoWrapper = styled.div`
  height: 18px;
  display: flex;
  align-items: center;
  margin-left: 22px;
  width: calc(100vw - 40px);
  max-width: 1000px;
  flex: 1;
  justify-content: space-between;

  ${breakpoint('tablet')`
   height: 29px;
   margin-left: 8px;
  `};
`;

const Logo = styled.img`
  max-height: 100%;
  opacity: 0.35;
  filter: grayscale(100%);

  &:hover {
    opacity: 1;
    filter: grayscale(0);
  }
`;

const LogoLink = styled.a`
  margin-right: 33px;
  height: 100%;
  cursor: pointer;

  &:last-of-type {
    margin-right: 0;
  }

  ${breakpoint('tablet')`
    margin-right: 59px;
  `};
`;

const LogoComponent = ({ link, ...rest }) => (
  <LogoLink href={link} rel="noopener noreferrer" target="_blank">
    <Logo {...rest} />
  </LogoLink>
);

const Logos = () => {
  return (
    <Wrapper>
      <LogoWrapper>
        <LogoComponent
          src={Farmacie}
          alt="farmacie.md"
          link="https://farmacie.md"
        />
        <LogoComponent
          src={Maximum}
          alt="maximum.md"
          link="http://maximum.md/"
        />
        <LogoComponent
          src={Felicia}
          alt="felicia.md"
          link="https://felicia.md/ro/"
        />
        <LogoComponent
          src={Purcari}
          alt="purcari.md"
          link="https://purcari.wine/ro/"
        />
        <LogoComponent src={Verde} alt="verde.md" link="http://verde.md/ru/" />
        <LogoComponent
          src={Invito}
          alt="invito.md"
          link="http://invito.md/ru/"
        />
      </LogoWrapper>
    </Wrapper>
  );
};

export default Logos;
